/**
 * Landing.tsx
 * -----------
 * Landing page for the tutorial.
 * - Welcomes the user and explains the process.
 * - Resets progress on mount.
 */


import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from './common/Button';
import { useProgress } from '../context/ProgressContext';
import Box from './common/Box';

const Landing: React.FC = () => {
  const history = useHistory();
  const { setStep, language } = useProgress();
  const lang = (['en', 'fi', 'sv'].includes(language) ? language : 'fi') as 'en' | 'fi' | 'sv';

  const t = {
    landingTitle: {
      en: 'Welcome',
      fi: 'Tervetuloa',
      sv: 'Välkommen',
    },
    instructions: {
      en: (
        <>
          Go through the learning modules/slides and do the final test to get connected to the Wi-Fi
          <br />
          🫵 You will have to complete the test to unlock Wi-Fi.
          <br />
        </>
      ),
      fi: 'Seuraa ohjeita yhdistääksesi Wi-Fiin turvallisesti ja helposti.',
      sv: 'Följ stegen för att ansluta till Wi-Fi säkert och enkelt.',
    },
    start: {
      en: 'Start',
      fi: 'Aloita',
      sv: 'Starta',
    },
  };

  // Reset progress when landing
  React.useEffect(() => {
    setStep(0);
  }, [setStep]);

  return (
    <main className="flex w-full h-full justify-center">
      <Box className="justify-evenly h-2/6 w-4/6 gap-4">
        <h1 className="text-4xl font-extrabold text-blue-700 text-center  leading-tight">
          {t.landingTitle[lang]}
        </h1>
        <p className="text-blue-800 text-center w-full font-medium">
          {t.instructions[lang]}
        </p>
        <Button gradient onClick={() => history.push('/crash-course')} className="w-1/6">
          {t.start[lang]}
        </Button>
      </Box>
    </main>
  );
};

export default Landing;
